export default class StepList {
    constructor($el) {
        this.$el = $el;
        this.$timeline = this.$el.querySelector('.step-list__timeline');
        this.$track = this.$el.querySelector('.step-list__track');
        this.$items = Array.from(this.$el.querySelectorAll('[data-step-list-item]'));
        this.ticking = false;
        this.currentProgress = 0;
        this.targetProgress = 0;
        this.animationFrame = null;

        if (!this.$timeline || !this.$track || !this.$items.length) {
            return;
        }

        this.updateProgress = this.updateProgress.bind(this);
        this.requestTick = this.requestTick.bind(this);
        this.animateProgress = this.animateProgress.bind(this);
        this.getTriggerOffset = this.getTriggerOffset.bind(this);

        this.$el.classList.add('step-list--enhanced');

        window.addEventListener('scroll', this.requestTick, {passive: true});
        window.addEventListener('resize', this.requestTick);

        setTimeout(() => this.requestTick(), 100);
    }

    requestTick() {
        if (this.ticking) {
            return;
        }

        this.ticking = true;
        window.requestAnimationFrame(() => {
            this.updateProgress();
            this.ticking = false;
        });
    }

    animateProgress() {
        const delta = this.targetProgress - this.currentProgress;

        if (Math.abs(delta) < 0.0025) {
            this.currentProgress = this.targetProgress;
            this.animationFrame = null;
        } else {
            this.currentProgress += delta * 0.12;
            this.animationFrame = window.requestAnimationFrame(this.animateProgress);
        }

        const trackRect = this.$track.getBoundingClientRect();
        const progressLineY = trackRect.top + (trackRect.height * this.currentProgress);

        this.$el.style.setProperty('--step-list-progress', this.currentProgress.toFixed(4));

        this.$items.forEach(($item) => {
            const marker = $item.querySelector('.step-list__marker');
            const markerRect = (marker || $item).getBoundingClientRect();
            const markerActivationPoint = markerRect.top + (markerRect.height * 0.2);
            const isActive = markerActivationPoint <= progressLineY;

            $item.classList.toggle('step-list__item--active', isActive);
        });
    }

    getTriggerOffset(viewportHeight) {
        if (window.matchMedia('(max-width: 767px)').matches) {
            return viewportHeight * 0.75;
        }

        return viewportHeight * 0.65;
    }

    updateProgress() {
        const trackRect = this.$track.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        const triggerY = this.getTriggerOffset(viewportHeight);

        const rawProgress = (triggerY - trackRect.top) / trackRect.height;

        this.targetProgress = Math.min(Math.max(rawProgress, 0), 1);

        if (!this.animationFrame) {
            this.animationFrame = window.requestAnimationFrame(this.animateProgress);
        }
    }
}